import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type RefNumRequirement = {
  isFavorite: boolean;
  isRequiredForInvoicing: boolean;
  isRequiredForOrder: boolean;
  isRequiredForQuote: boolean;
  qualifier: string;
  qualifierId: number;
};

export type GetRefNumRequirementsResponse = {
  requirements: RefNumRequirement[];
};

/**
 * Ref-num-requirements. Caller sends at most one: customerExternalTmsId (e.g. 3G form) or customerID (internal id).
 * Same pattern as getLocations.
 */
export async function getRefNumRequirements(
  tmsID: number,
  customerExternalTmsId?: string,
  customerID?: number
): Promise<Result<GetRefNumRequirementsResponse, ApiError>> {
  try {
    const params = new URLSearchParams({ tmsID: tmsID.toString() });
    if (customerExternalTmsId != null && customerExternalTmsId !== '') {
      params.append('externalTMSID', customerExternalTmsId);
    } else if (customerID != null) {
      params.append('customerID', String(customerID));
    }

    const response = await axios.get<GetRefNumRequirementsResponse>(
      `/customers/ref-num-requirements?${params.toString()}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getRefNumRequirements' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get reference number requirements' });
    }

    if (error && error.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message:
        error.response?.data.message ||
        'Failed to get reference number requirements',
    });
  }
}
